module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "backTop"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-arrow-up"
    },
    on: {
      "click": _vm.backTop
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17f9dec8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/layout/BackTop.vue
// module id = 640
// module chunks = 25